'use strict';

(function () {
    const { queryFirst } = require('./domUtil');
    const { body } = document;
    const oneTrustSettings = queryFirst('#onetrust-settings') || { dataset: {} };
    const { onetrustEnabled, onetrustDoNotSellFormUrl, onetrustPrivacyFormUrl } = oneTrustSettings.dataset;
    const { EVENT_KEY_SPACE, EVENT_KEY_ENTER, EVENT_KEY_ESC, KEYCODE_ENTER, KEYCODE_SPACE } = require('./constants');

    if (!onetrustEnabled || onetrustEnabled === 'false') return;

    let lastCookieTrigger = null; // element that opened OneTrust panel

    // Cookie preferences links (open OneTrust)
    body.addEventListener('click', e => {
        const { target } = e;
        const trigger = target.closest('.cookie-preferences');

        if (!trigger || !window.OneTrust) return;

        e.preventDefault();
        lastCookieTrigger = trigger; // remember opener
        OneTrust.ToggleInfoDisplay();
    });

    if (!onetrustDoNotSellFormUrl || !onetrustPrivacyFormUrl) return;

    // Privacy form links
    const { dialogTemplate, oneTrust: oneTrustTemplates } = require('./templates');
    const doNotSellFormSelector = '.onetrust-do-not-sell-link';
    const privacyFormSelector = '.onetrust-privacy-link';
    const privacyManagementHeading = 'Privacy Management';
    const oneTrustDialogId = 'onetrust-privacy-dialog';
    let oneTrustDialog = queryFirst(`#${oneTrustDialogId}`);

    const showDialog = content => {
        if (!oneTrustDialog) {
            oneTrustDialog = document.createElement('div');
            oneTrustDialog.id = oneTrustDialogId;
            document.body.appendChild(oneTrustDialog);
        }

        // Close any open OneTrust dialog
        try { OneTrust.Close(); } catch (e) {}

        $(oneTrustDialog).html(content).find('.modal').modal('show');
    };

    const doNotSellDialog = dialogTemplate({
        buttons: [],
        className: 'onetrust-do-not-sell-dialog',
        modalContentHeading: privacyManagementHeading,
        modalContentBody: `${oneTrustTemplates.privacyDialogCookieBanner}<iframe src="${onetrustDoNotSellFormUrl}"></iframe>`,
        slideOut: true
    });

    const privacyDialog = dialogTemplate({
        buttons: [],
        className: 'onetrust-privacy-dialog',
        modalContentHeading: privacyManagementHeading,
        modalContentBody: `${oneTrustTemplates.privacyDialogCookieBanner}<iframe src="${onetrustPrivacyFormUrl}"></iframe>`,
        slideOut: true
    });

    body.addEventListener('click', e => {
        const { target } = e;

        if (target.closest(doNotSellFormSelector)) {
            e.preventDefault();
            showDialog(doNotSellDialog);
        } else if (target.closest(privacyFormSelector)) {
            e.preventDefault();
            showDialog(privacyDialog);
        }
    });

    // ============================
    // OneTrust panel focus return
    // ============================

    function isVisible(el) {
        if (!el || !el.isConnected) return false;
        const rects = el.getClientRects();
        return rects && rects.length > 0;
    }

    function getFooterCookiePref() {
        return queryFirst('#footercontent .cookie-preferences');
    }

    function getAnyCookiePref() {
        return queryFirst('.cookie-preferences');
    }

    function refocusTrigger() {
        let target = isVisible(lastCookieTrigger) ? lastCookieTrigger : null;

        if (!target) {
            const footer = getFooterCookiePref();
            if (isVisible(footer)) target = footer;
        }

        if (!target) {
            const any = getAnyCookiePref();
            if (isVisible(any)) target = any;
        }

        if (!target) target = document.body;

        setTimeout(() => {
            try { target.focus(); } catch (_) {}
        }, 0);
    }

    function isOneTrustPanelVisible() {
        return $('#onetrust-pc-sdk:visible').length > 0;
    }

    // Close icon click / Enter / Space -> refocus opener (with fallbacks)
    $(document).on('click keydown', '#onetrust-consent-sdk .ot-close-icon', e => {
        const { type, key, keyCode } = e;
        const isClick = type === 'click';
        const isEnter = type === 'keydown' && (key === EVENT_KEY_ENTER || keyCode === KEYCODE_ENTER);
        const isSpace = type === 'keydown' && (key === EVENT_KEY_SPACE || keyCode === KEYCODE_SPACE);

        if (!(isClick || isEnter || isSpace)) return;

        refocusTrigger();
    });

    // ESC while OneTrust open -> refocus opener (with fallbacks)
    document.addEventListener('keydown', e => {
        if (e.key !== EVENT_KEY_ESC) return;

        if (isOneTrustPanelVisible()) {
            // Wait for OneTrust transition to finish
            setTimeout(refocusTrigger, 300);
        }
    }, true);
})();
